import Campaign from '../store/Campaign';
import { ActionType, endLightning } from 'owa-lightning-core-v2';
import { CAMPAIGN_ENDED } from './eventNames';
import { setCampaignVisibility } from 'mini-campaign/lib/mutators/setCampaignVisibility';
import { setLastShownLightning } from '../mutators/setLastShownLightning';

/**
 * Function to end the lightning and set the campaign view state to false
 * @param campaign Campaign object
 */
export const endCampaign = <T extends {}>(campaign: Campaign<T>, actionType: ActionType) => {
    campaign.promiseResolve && campaign.promiseResolve(null);
    const { logState, logger } = campaign;
    if (logState && !logState[CAMPAIGN_ENDED]) {
        logger?.(CAMPAIGN_ENDED, { id: campaign.getId() });
        logState[CAMPAIGN_ENDED] = true;
    }

    // This is required to be called to set last shown lightning id otherwise endlightning may not happen if the id does not match.
    campaign.getLightningId() && setLastShownLightning(campaign.getLightningId());
    actionType && endLightning.importAndExecute(campaign.getLightningId(), actionType);
    setCampaignVisibility(campaign, false);
};
